export default "__VITE_ASSET__da0Caew4__"